import _ from 'lodash'
import * as actionTypes from './actionTypes'
import { getAxios, getPreviewDynamicData } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
import { fromJS, List, Map } from 'immutable'
import { processChangeLinearLoadingStatus } from './processButtonAction'
import {
  getElementFromPath,
  getState,
  getStripElementFromPath,
  toPlainValue,
  updateOldValue,
} from '../../lib/processPortalRules'
import { getFormDateFormat } from '../../lib/format'
import moment from 'moment'
import { postDownloadFileWithAjax } from '../../lib/DownloadFileWithAjax'
import { sendLWCSizeToParent } from './sendLWCSizeToParent'
import { getPageUID } from '../../lib/getValueByType'

const axios = getAxios()

const isOnlyNumKeys = (obj) => {
  const keys = _.keys(obj)
  const numKeys = _.filter(keys, (key) => /^[0-9]+$/.test(key))
  return numKeys.length === keys.length
}

export const fixObjectArrayState = (state) => {
  return _.reduce(
    state,
    (retObj, obj, key) => {
      if (_.isObject(obj) && isOnlyNumKeys(obj)) {
        let arrObj = []
        let maxKey = _.maxBy(_.keys(obj), (key) => parseInt(key, 10))
        maxKey = parseInt(maxKey, 10) + 1
        if (!maxKey) {
          maxKey = _.size(obj) || 1
        }
        _.times(maxKey, (index) => {
          arrObj.push(_.get(obj, [index], ''))
        })
        retObj[key] = arrObj
      } else {
        retObj[key] = obj
      }
      return retObj
    },
    {}
  )
}

export const processDocGenTitanSign = async (params, dispatch, getState) => {
  if (!params.recordID || !params.actionID || !params.mapURLTo) {
    return false
  }

  dispatch({
    type: actionTypes.SHOW_LOADING_WINDOW,
    payload: {
      messages: [],
    },
  })

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/titansign/geturl', {
        actionID: params.actionID,
        recordID: params.recordID,
        recordIdProt: params.recordIdProt,
        action: params.titanSignAction,
        webState: params.webState,
      })
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { status, data } = await recursiveProcessGet(0)

  dispatch({
    type: actionTypes.CLOSE_LOADING_WINDOW,
  })

  if (data.status) {
    sendLWCSizeToParent(false, true)
    if (params.callbackAction == 'mapTo') {
      let mapURLTo = params.mapURLTo
      if (mapURLTo.group == 'param') {
        ftSetParamValueById(mapURLTo.value, data.url)
      } else if (mapURLTo.group) {
        let val = String(mapURLTo.value).split(':')
        ftSetValueByID(val[0], val[1], data.url)
      }
    } else if (params.titanSignAction != 'generate') {
      let state = getState()
      let width = window.innerWidth * 0.8
      let height = window.innerHeight * 0.8
      if (params.customSizes?.width) {
        const unit = _.get(params, ['customSizes', 'widthUnit'], 'px')
        if (unit === 'px') {
          width = params.customSizes?.width
        } else {
          width = `${params.customSizes?.width}${unit}`
        }
      }
      if (params.customSizes?.height) {
        const unit = _.get(params, ['customSizes', 'heightUnit'], 'px')
        if (unit === 'px') {
          height = params.customSizes?.height
        } else {
          height = `${params.customSizes?.height}${unit}`
        }
      }
      state = state.setIn(['widgets', 'RedirectModal', 'needShow'], true).setIn(
        ['widgets', 'RedirectModal', 'params'],
        fromJS({
          url: data.url,
          width,
          height,
          hideMenu: false,
          positionOfModal: 'center',
          params: [],
          signCancel: params.signCancel,
          sign: params.sign,
          allowDynamicSize: params.allowDynamicSize,
          dynamic: params.dynamic,
          customSizes: params.customSizes,
        })
      )
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state,
        },
      })
    }
  }
}

export const collectAutoPDFState = (appState) => {
  let offset = (new Date().getTimezoneOffset() / 60) * 3600 * 1000

  let pageUid = getPageUID(appState.get('page'), appState.getIn(['project', 'Pages']))
  let meta = appState.getIn(['meta', pageUid])
  return {
    meta: {
      [pageUid]: meta,
    },
    state: appState.get('state', Map()),
    rules: appState.get('rules', Map()),
    params: appState.get('params', Map()),
    filter: appState.get('filter', Map()),
    metaInfo: appState.get('metaInfo', Map()),
    layoutMode: appState.get('layoutMode', 'lg'),
    timeOffset: offset,
  }
}

export const processDocGen = async (params, dispatch, getAppState) => {
  const callbackFinishDocGen = () => {
    try {
      if (params && params.nextNode) {
        let state = getAppState()
        let cacheList = state.getIn(['__cache__'], List())
        cacheList = cacheList.concat(fromJS(params.nextNode))
        state = state.setIn(['__cache__'], cacheList)
        dispatch({
          type: actionTypes.SET_STORE,
          payload: {
            store: state,
          },
        })
      }
    } catch (err) {
      console.error(err.stack)
    }
  }

  if (params.action.type === 'AUTO_PDF') {
    let state = getAppState()
    try {
      if (state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'allowFreeze'])) {
        dispatch({
          type: actionTypes.SHOW_LOADING_WINDOW,
          payload: {
            messages: [],
          },
        })
      }
      if (state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'allowProgressBar'])) {
        dispatch(processChangeLinearLoadingStatus(true))
      }
      const autoPDFState = collectAutoPDFState(state)
      let fileName = ''
      if (_.get(params, ['action', 'fields', 'isDynamicName']) && params.fileName) {
        fileName = params.fileName
      } else if (_.get(params, ['action', 'fields', 'customFileName'])) {
        fileName = _.get(params, ['action', 'fields', 'customFileName'])
      }
      let status = await postDownloadFileWithAjax(
        '/webprojects/autopdf',
        fileName,
        {
          actionID: params.actionID,
          state: autoPDFState,
        },
        callbackFinishDocGen
      )
    } catch (error) {
      console.error(error)
    }
    if (state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'allowProgressBar'])) {
      dispatch(processChangeLinearLoadingStatus(false))
    }
    if (state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'allowFreeze'])) {
      dispatch({
        type: actionTypes.CLOSE_LOADING_WINDOW,
      })
    }
    return true
  }

  if (!params.recordID || !params.actionID) {
    return false
  }

  // if(!requestData || !requestData.recordID || !requestData.url) {
  //     return false;
  // }

  dispatch({
    type: actionTypes.SHOW_LOADING_WINDOW,
    payload: {
      messages: [],
    },
  })

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      const currState = getState(state)
      const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
      let hashFields = {}
      try {
        let fieldsList = state
          .getIn(['project', 'Settings', 'store', 'public', params.actionID, 'templateFields'], List())
          .toJS()
        _.each(fieldsList, (row) => {
          if (row && row.value) {
            hashFields[row.value] = row
          }
        })
      } catch (err) {}

      const fields = state
        .getIn(['project', 'Settings', 'store', 'public', params.actionID, 'templateFields'], List())
        .reduce((r, v) => {
          const group = v.get('group')
          if (group === 'param') {
            return r.set(v.get('value'), state.getIn(['params', String(v.get('value')).replace('param', '')], ''))
          } else if (group === 'pageParam') {
            const [pageUID, paramID] = String(v.get('value')).split(':')
            return r.set(v.get('value'), state.getIn(['state', pageUID, paramID], ''))
          } else {
            const value = String(v.get('value'))
            const wordControl = v.get('control')
            if (_.startsWith(group, 'formWidget:') || _.startsWith(group, 'listWidget:')) {
              return r.set(value, toPlainValue(_.get(currState, value.replace(/:/g, '.'), '')))
            } else if (_.startsWith(group, 'form:')) {
              return r.set(
                value,
                toPlainValue(_.get(currState, `${_.get(window.__FT_APP_STATE__, 'widget._id')}.${value}`, null))
              )
            } else if (group === 'smartv') {
              return r.set(value, isUserSignIn ? 'true' : '')
            } else {
              let path = updateOldValue(value).split(':')
              let stripPath = updateOldValue(value).split(/:/g).slice(0, 2).join(':')
              let elem = getElementFromPath(path, state)
              let strip = getStripElementFromPath(path, state)
              if (
                strip.get('type') === 'RepeatAutoFit' ||
                (strip.get('type') === 'Strip' &&
                  (strip.getIn(['props', 'isRepeat'], false) || strip.getIn(['props', 'isRepeatCol'], false)))
              ) {
                let stripState = fixObjectArrayState(
                  _.get(currState, updateOldValue(value).split(/:/g).slice(0, 2), '')
                )

                try {
                  _.each(stripState, (value, elID) => {
                    const elem = getElementFromPath([...path.slice(0, 2), elID], state)
                    if (Map.isMap(elem) && elem.get('type') === 'Image') {
                      if (value && value.IMG_SRC && _.isArray(value.IMG_SRC)) {
                        _.set(stripState, [elID], [])
                        _.each(value.IMG_SRC, (val, index) => {
                          _.set(stripState, [elID, index], toPlainValue(val))
                        })
                      }
                    } else if (
                      Map.isMap(elem) &&
                      elem.get('type') === 'FormField' &&
                      ['time', 'date', 'datetime'].includes(elem.getIn(['props', 'control']))
                    ) {
                      if (_.isArray(value)) {
                        _.each(value, (val, index) => {
                          let format = getFormDateFormat(
                            elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                            elem.getIn(['props', 'control'])
                          )
                          if (_.get(hashFields, [`${path.join(':')}:${elID}`, 'control'])) {
                            if (elem.getIn(['props', 'control']) === 'time') {
                              format = 'HH:mm'
                            } else if (['datetime'].includes(elem.getIn(['props', 'control']))) {
                              format = 'YYYY-MM-DDTHH:mm'
                            } else if (elem.getIn(['props', 'control']) === 'date') {
                              format = 'YYYY-MM-DD'
                            }
                          }
                          let date = moment(val)
                          if (date.format() !== 'Invalid date') {
                            _.set(stripState, [elID, index], date.format(format))
                          } else {
                            _.set(stripState, [elID, index], toPlainValue(val))
                          }
                        })
                      } else {
                        let val = value
                        let format = getFormDateFormat(
                          elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                          elem.getIn(['props', 'control'])
                        )
                        let date = moment(val)
                        if (date.format() !== 'Invalid date') {
                          _.set(stripState, [elID], date.format(format))
                        } else {
                          _.set(stripState, [elID], toPlainValue(val))
                        }
                      }
                    }
                  })
                } catch (error) {
                  console.error(error)
                }
                return r.set(stripPath, stripState)
              } else {
                if (elem.get('type') === 'Image') {
                  return r.set(value, toPlainValue(_.get(currState, [...path, 'IMG_SRC'], '')))
                } else if (elem.get('type') === 'Widget' && elem.getIn(['props', 'data', 'Type']) === 'ImageChoice') {
                  if (_.last(path) === 'ftListLabel') {
                    return r.set(value, toPlainValue(_.get(currState, [..._.initial(path), 'ftListValue'], '')))
                  }
                  return r.set(value, toPlainValue(_.get(currState, [...path, 'ftListValue'], '')))
                } else if (elem.get('type') === 'FormField' && ['time'].includes(elem.getIn(['props', 'control']))) {
                  let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                  let format = getFormDateFormat(
                    elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                    elem.getIn(['props', 'control'])
                  )
                  if (wordControl) {
                    format = 'HH:mm'
                  }
                  let date = moment(val)
                  if (date.format() !== 'Invalid date') {
                    return r.set(value, date.format(format))
                  } else {
                    date = moment(moment().format('YYYY-MM-DD') + 'T' + val)
                    if (date.format() !== 'Invalid date') {
                      return r.set(value, date.utc().format(format))
                    }
                  }
                  return r.set(value, val)
                } else if (
                  wordControl &&
                  elem.get('type') === 'FormField' &&
                  ['date', 'datetime'].includes(elem.getIn(['props', 'control']))
                ) {
                  let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                  let date = moment(val)
                  if (date.format() !== 'Invalid date') {
                    let format = ''
                    if (['datetime'].includes(elem.getIn(['props', 'control']))) {
                      format = 'YYYY-MM-DDTHH:mm'
                    } else if (elem.getIn(['props', 'control']) === 'date') {
                      format = 'YYYY-MM-DD'
                    }
                    return r.set(value, date.format(format))
                  } else {
                    return r.set(value, toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), '')))
                  }
                } else if (
                  elem.get('type') === 'FormField' &&
                  ['time', 'date', 'datetime'].includes(elem.getIn(['props', 'control']))
                ) {
                  let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                  let format = getFormDateFormat(
                    elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                    elem.getIn(['props', 'control'])
                  )
                  let date = moment(val)
                  if (date.format() !== 'Invalid date') {
                    return r.set(value, date.format(format))
                  } else {
                    return r.set(value, toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), '')))
                  }
                }
                return r.set(value, toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), '')))
              }
            }
          }
        }, Map())
        .toJS()
      let result = await axios.post('/webprojects/word/geturl', {
        actionID: params.actionID,
        recordID: params.recordID,
        recordIdProt: params.recordIdProt,
        action: params.buttonAction,
        fields,
      })
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let state = getAppState()
  if (
    state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'allowProgressBar']) &&
    !['interactive', 'preview'].includes(params.buttonAction)
  ) {
    dispatch(processChangeLinearLoadingStatus(true))
  }
  let { status, data } = await recursiveProcessGet(0)
  if (data.status) {
    if (
      !state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'allowFreeze']) ||
      ['interactive', 'preview'].includes(params.buttonAction)
    ) {
      dispatch({
        type: actionTypes.CLOSE_LOADING_WINDOW,
      })
    }
    state = getAppState()
    if (params.buttonAction === 'interactive') {
      let url
      let onSubmit = state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'onSubmit'], List())
      if (params.onSubmit) {
        onSubmit = onSubmit.concat(fromJS(params.onSubmit))
      }
      let onClose = state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'onClose'], List())
      if (params.onClose) {
        onClose = onClose.concat(fromJS(params.onClose))
      }
      const ui = state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'ui'], Map())
      let interactiveZoom = state.getIn(
        ['project', 'Settings', 'store', 'public', params.actionID, 'interactiveZoom'],
        ''
      )
      if (ui.get('customZoom')) {
        interactiveZoom = ui.getIn(['deviceZoom', state.get('layoutMode', 'lg')], '')
      }
      state = state
        .setIn(['widgets', 'PreviewDocGen', 'needShow'], true)
        .setIn(['widgets', 'PreviewDocGen', 'customActions'], fromJS(params.previewActions))
        .setIn(
          ['widgets', 'PreviewDocGen', 'params'],
          fromJS({
            url: data.url,
            signURL: data.signURL,
            hideDownloadButton: _.get(params, ['action', 'hideDownloadButton']),
            previewWith: _.get(params, ['action', 'fields', 'previewWith']),
            width: window.innerWidth * 0.8,
            height: window.innerHeight * 0.8,
            hideMenu: false,
            positionOfModal: 'center',
            params: [],
            isInteractive: true,
            onSubmit,
            onClose,
            ui,
            lang: state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'lang'], Map()),
            interactiveActions: state.getIn(
              ['project', 'Settings', 'store', 'public', params.actionID, 'interactiveActions'],
              Map()
            ),
            interactiveZoom,
            settingID: params.actionID,
          })
        )
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state,
        },
      })
    } else if (params.buttonAction == 'edit') {
      let state = getAppState()
      let onSubmit = state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'onEditSubmit'], List())
      if (params.onSubmit) {
        onSubmit = onSubmit.concat(fromJS(params.onSubmit))
      }
      let onClose = state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'onEditClose'], List())
      if (params.onClose) {
        onClose = onClose.concat(fromJS(params.onClose))
      }
      state = state
        .setIn(['widgets', 'PreviewDocGen', 'needShow'], true)
        .setIn(['widgets', 'PreviewDocGen', 'customActions'], fromJS(params.editActions))
        .setIn(
          ['widgets', 'PreviewDocGen', 'params'],
          fromJS({
            url: data.url,
            signURL: data.signURL,
            hideDownloadButton: _.get(params, ['action', 'hideDownloadButton']),
            previewWith: _.get(params, ['action', 'fields', 'previewWith']),
            width: window.innerWidth * 0.8,
            height: window.innerHeight * 0.8,
            hideMenu: false,
            positionOfModal: 'center',
            params: [],
            isEdit: true,
            onSubmit,
            onClose,
            ui: state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'ui'], Map()),
            lang: state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'lang'], Map()),
            editoutputFormat: state.getIn(
              ['project', 'Settings', 'store', 'public', params.actionID, 'editoutputFormat'],
              ''
            ),
            actionID: params.actionID,
          })
        )
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state,
        },
      })
    } else if (params.buttonAction == 'preview') {
      let url
      let state = getAppState()
      if (
        ['titan', 'titanMini', 'titanDocx', 'titanDocxHtml'].indexOf(
          _.get(params, ['action', 'fields', 'previewWith'])
        ) !== -1 ||
        _.get(params, ['action', 'type']) === 'XLSXGEN'
      ) {
        state = state
          .setIn(['widgets', 'PreviewDocGen', 'needShow'], true)
          .setIn(['widgets', 'PreviewDocGen', 'customActions'], fromJS(params.previewActions))
          .setIn(
            ['widgets', 'PreviewDocGen', 'params'],
            fromJS({
              url: data.url,
              previewWith: _.get(params, ['action', 'fields', 'previewWith']),
              hideDownloadButton: _.get(params, ['action', 'hideDownloadButton']),
              width: window.innerWidth * 0.8,
              height: window.innerHeight * 0.8,
              hideMenu: false,
              positionOfModal: 'center',
              params: [],
              type: _.get(params, ['action', 'type']),
              fileName: _.get(params, ['fileName']),
              previewZoom: state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'previewZoom'], ''),
              lang: state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'lang'], Map()),
              previewActions: params.previewActionsList ?? {},
            })
          )
      } else {
        if (_.get(params, ['action', 'fields', 'previewWith']) == 'Google') {
          url = 'https://docs.google.com/gview?url=' + encodeURIComponent(data.url) + '&embedded=true'
        } else {
          url = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(data.url)
        }
        state = state
          .setIn(['widgets', 'RedirectModal', 'needShow'], true)
          .setIn(['widgets', 'RedirectModal', 'customActions'], fromJS(params.previewActions))
          .setIn(
            ['widgets', 'RedirectModal', 'params'],
            fromJS({
              url: url,
              width: window.innerWidth * 0.8,
              height: window.innerHeight * 0.8,
              hideMenu: false,
              positionOfModal: 'center',
              params: [],
              previewActions: params.previewActionsList ?? {},
            })
          )
      }
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state,
        },
      })
    } else {
      let downloadURL = data.url
      if (_.get(params, ['options', 'ftDocGenHash'])) {
        downloadURL += '/' + _.get(params, ['options', 'ftDocGenHash'])
      }
      axios
        .get(downloadURL, { responseType: 'blob' })
        .then(function (result) {
          if (result.status == 200) {
            let fileName = ''
            if (_.get(params, ['action', 'fields', 'isDynamicName']) && params.fileName) {
              fileName = params.fileName
            } else if (_.get(params, ['action', 'fields', 'customFileName'])) {
              fileName = _.get(params, ['action', 'fields', 'customFileName'])
            }

            if (result.headers && result.headers['content-type']) {
              if (!fileName) {
                fileName = 'Mapping'
              }
              if (result.headers['content-type'] == 'application/pdf') {
                fileName += '.pdf'
              } else if (
                result.headers['content-type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              ) {
                fileName += '.xlsx'
              } else {
                fileName += '.docx'
              }
            }

            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              window.navigator.msSaveBlob(result.data, fileName)
            } else {
              var URL = window.URL || window.webkitURL
              var downloadUrl = URL.createObjectURL(result.data)

              // use HTML5 a[download] attribute to specify filename
              var a = document.createElement('a')
              // safari doesn't support this yet
              if (
                typeof a.download === 'undefined' ||
                String(window.navigator.userAgent).toLowerCase().indexOf('firefox') > -1
              ) {
                try {
                  let modal = window.open(downloadUrl)
                  if (!modal) {
                    window.__FT_PROJECT__API__.addToast(
                      'In order to download your file Titan needs to open a new tab. Please make sure pop-ups are not blocked in your browser.',
                      { appearance: 'error' }
                    )
                  }
                } catch (err) {
                  console.error(err)
                }
              } else {
                a.target = '_blank'
                a.href = downloadUrl
                a.download = fileName
                document.body.appendChild(a)
                a.click()
              }

              dispatch({
                type: actionTypes.CLOSE_LOADING_WINDOW,
              })

              setTimeout(function () {
                URL.revokeObjectURL(downloadUrl)
                callbackFinishDocGen()
              }, 100) // cleanup
            }
          }
          dispatch({
            type: actionTypes.CLOSE_LOADING_WINDOW,
          })
          dispatch(processChangeLinearLoadingStatus(false))
        })
        .catch(function (err) {
          console.error(err)
          dispatch({
            type: actionTypes.CLOSE_LOADING_WINDOW,
          })
          dispatch(processChangeLinearLoadingStatus(false))
        })
    }
    //     let separator = '';
    //     if(String(requestData).indexOf('?') > -1) {
    //         separator = '&'
    //     } else {
    //         separator = '?'
    //     }
    //     location.href = `${requestData.url}${separator}ftSFToken=${data.token}&ftlwcid=${requestData.recordID}`
  } else {
    dispatch({
      type: actionTypes.CLOSE_LOADING_WINDOW,
    })
  }
}
